import { render } from "./ListSeminarKursusView.vue?vue&type=template&id=fa20f566"
import script from "./ListSeminarKursusView.vue?vue&type=script&lang=js"
export * from "./ListSeminarKursusView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__